import { Button, Grid, Menu, MenuItem, Theme, useMediaQuery } from '@mui/material';
import { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDownIcon } from '../../../assets/icons';
import { APP_URLS } from '../../../routes/urls';
import { AppIcon } from '../../app-icon/AppIcon';
import { desktopHeaderStyles } from '../desktop-header/styles';
import { accountMenuStyles } from './styles';

export const AuthHeaderMenu: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const desktopMenuAnchorEl = useRef(null);
  const toggleIsMenuOpen = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const tabletMenuAnchorEl = useRef(null);
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));
  return !isDesktop ? (
    <>
      <Button
        endIcon={<AppIcon sx={accountMenuStyles.myAccountIcon} Icon={ChevronDownIcon} />}
        ref={tabletMenuAnchorEl}
        onClick={toggleIsMenuOpen}
        color="primary"
        variant="light"
        component="button"
      >
        My account
      </Button>
      <Menu
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorEl={tabletMenuAnchorEl.current}
        open={isMenuOpen}
        onClose={toggleIsMenuOpen}
        onClick={toggleIsMenuOpen}
      >
        <MenuItem component={Link} sx={accountMenuStyles.accountMenuItem} to={APP_URLS.signIn}>
          Sign In
        </MenuItem>
        <MenuItem component={Link} sx={accountMenuStyles.accountMenuItem} to={APP_URLS.signUp}>
          Create New Account
        </MenuItem>
        <MenuItem component={Link} sx={accountMenuStyles.accountMenuItem} to={APP_URLS.academicAdminRegister}>
          Become Academy Admin
        </MenuItem>
        <MenuItem component={Link} sx={accountMenuStyles.accountMenuItem} to={APP_URLS.scholarshipAdminRegister}>
          Become Scholarship Provider
        </MenuItem>
      </Menu>
    </>
  ) : (
    <Grid container columnSpacing={1.5} flexWrap="nowrap" whiteSpace="nowrap" alignItems="center">
      <Grid item>
        <Button
          ref={desktopMenuAnchorEl}
          onClick={toggleIsMenuOpen}
          color="secondary"
          sx={desktopHeaderStyles.menuLink}
        >
          Register as admin
        </Button>
        <Menu
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorEl={desktopMenuAnchorEl.current}
          open={isMenuOpen}
          onClose={toggleIsMenuOpen}
          onClick={toggleIsMenuOpen}
        >
          <MenuItem component={Link} sx={accountMenuStyles.accountMenuItem} to={APP_URLS.academicAdminRegister}>
            Become Academy Admin
          </MenuItem>
          <MenuItem component={Link} sx={accountMenuStyles.accountMenuItem} to={APP_URLS.scholarshipAdminRegister}>
            Become Scholarship Provider
          </MenuItem>
        </Menu>
      </Grid>
      <Grid item>
        <Button component={Link} to={APP_URLS.signIn} variant="default">
          Sign In
        </Button>
      </Grid>
      <Grid item>
        <Button component={Link} to={APP_URLS.signUp} variant="contained">
          Create Account
        </Button>
      </Grid>
    </Grid>
  );
};
